import React from 'react';

interface StatusBarProps {
  statusText: string;
  simulationRunning: boolean;
}

const StatusBar: React.FC<StatusBarProps> = ({ statusText, simulationRunning }) => (
  <div className="opm-x6-status" style={{ transform: 'none', WebkitTransform: 'none' }}>
    <span className={`dot ${simulationRunning ? 'running' : ''}`} style={{ transform: 'none', WebkitTransform: 'none' }} />
    <span style={{ transform: 'none', WebkitTransform: 'none' }}>{statusText}</span>
  </div>
);

export default StatusBar;